import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TagCloud } from "react-tagcloud";
import _ from "lodash";

import { addCheckedTags, removeAllCheckedTags } from "../../epics/stepThreeEpics";
import ChipMobile from "../../components/chipMobile";
import taxonomyData from "../../taxonomyData.json";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  makeStyles,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Button
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

const useStyles = makeStyles(
  () => ({
    accordion: {
      borderRadius: "12px !important",
      boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
      margin: "10px !important",
      "&::before": {
        display: "none"
      }
    },
    accordionDetails: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center"
    },
    card: {
      borderRadius: "12px !important",
      boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
      margin: "10px 10px 65px 10px !important"
    },
    dotIcon: {
      marginRight: "8px"
    },
    innerAccordion: {
      borderRadius: "12px !important",
      boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
      margin: "10px 0px !important",
      "&::before": {
        display: "none"
      }
    },
    heading: {
      fontWeight: "bold"
    },
    keyphrasesAccordion: {
      flexWrap: "wrap",
      padding: "8px 12px 16px"
    },
    selectAllWrapper: {
      display: "flex",
      justifyContent: "center",
      marginTop: "10px",
      width: "100%"
    },
    tag: {
      backgroundColor: "transparent",
      border: "3px solid",
      color: "#424242",
      cursor: "pointer",
      margin: "4px",
      padding: 0,
      width: "fit-content"
    }
  }),
  { name: "MobileStepThree" }
);

export default function MobileStepThree() {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [expanded, setExpanded] = React.useState("panel1");
  const [toggleTags, setToggleTags] = useState(true);

  const dispatch = useDispatch();

  const keyphrases = useSelector((state) => state.keyphrases);
  const checkedCardOne = useSelector((state) => state.checkedCardStepOne);
  const checkedCardTwo = useSelector((state) => state.checkedCardStepTwo);
  const taxonomyGroups = useSelector((state) => state.taxonomyGroups); // in 1. card mit farben für tags (rausfiltern von taggroups auf rechter seite)
  const taxonomyColors = useSelector((state) => state.taxonomyGroupColors);
  const taxonomyGroupsMerged = taxonomyGroups[checkedCardOne + " " + checkedCardTwo];
  const data = keyphrases[checkedCardOne + " " + checkedCardTwo]; // keyphrases aus beiden texten

  useEffect(() => {
    let selectedTags = [];
    if (taxonomyGroupsMerged) {
      Object.keys(data).forEach((key) => {
        selectedTags.push({ value: key, count: 20, selected: true });
        setTags(selectedTags);
      });
    }
  }, [data, taxonomyGroupsMerged]);

  const trees = [];
  const cars = [];
  const stars = [];

  taxonomyData.Tree.forEach((tree) => trees.push({ value: tree, count: 20, color: "#ff936e" }));
  taxonomyData.Car.forEach((car) => cars.push({ value: car, count: 20, color: "#7f0133" }));
  taxonomyData.Star.forEach((star) => stars.push({ value: star, count: 20, color: "#4054db" }));

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleAllToggle = () => {
    const text = checkedCardOne + " " + checkedCardTwo;
    if (toggleTags !== true) {
      dispatch(
        addCheckedTags(
          text,
          _.map(tags, (tag) => tag.value)
        )
      );
    } else {
      dispatch(removeAllCheckedTags(text));
    }
    setToggleTags(!toggleTags);
  };

  const predefinedTags = (tag, size, color) => {
    return (
      <Chip
        key={tag.value}
        label={tag.value}
        style={{ borderColor: tag.color, backgroundColor: tag.color, color: "#fff" }}
        className={classes.tag}
      />
    );
  };

  if (!_.isEmpty(taxonomyGroupsMerged)) {
    tags.forEach((tag) => {
      taxonomyGroupsMerged.Car.some((car) => {
        if (tag.value === car.node) {
          tag.color = "#7f0133";
          return true;
        } else {
          return false;
        }
      });
      taxonomyGroupsMerged.Tree.some((tree) => {
        if (tag.value === tree.node) {
          tag.color = "#ff936e";
          return true;
        } else {
          return false;
        }
      });
      taxonomyGroupsMerged.Star.some((star) => {
        if (tag.value === star.node) {
          tag.color = "#4054db";
          return true;
        } else {
          return false;
        }
      });
      taxonomyGroupsMerged.noGroup?.some((nogroup) => {
        if (tag.value === nogroup.node) {
          tag.color = "#aaaaaa";
          return true;
        } else {
          return false;
        }
      });
    });
  }

  return (
    <div>
      <Accordion className={classes.accordion} expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography className={classes.heading}>Extrahierte Schlüsselwörter</Typography>
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.accordionDetails }} className={classes.keyphrasesAccordion}>
          {!_.isEmpty(taxonomyColors) && !_.isEmpty(taxonomyGroupsMerged) ? (
            _.map(tags, (tag, index) => {
              return <ChipMobile key={index} tag={tag} tags={tags} setTags={setTags} />;
            })
          ) : (
            <div className={classes.progressContainer}>
              <CircularProgress />
            </div>
          )}
          <div className={classes.selectAllWrapper}>
            <Button variant="outlined" onClick={handleAllToggle}>
              Alle Schlüsselwörter {toggleTags ? " abwählen" : " auswählen"}
            </Button>
          </div>
        </AccordionDetails>
      </Accordion>

      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.heading}>Bestehende Unternehmenstaxonomie</Typography>

          <Accordion
            className={classes.innerAccordion}
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            style={{
              backgroundColor: "rgb(127, 1, 51, 0.1)"
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
              <FiberManualRecordIcon className={classes.dotIcon} style={{ color: "rgb(127, 1, 51)" }} />
              <Typography style={{ color: "rgb(127, 1, 51)", fontWeight: "bold" }}>Car</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TagCloud
                className={classes.accordionDetails}
                tags={cars}
                renderer={predefinedTags}
                disableRandomColor={true}
                shuffle={false}
                minSize={1}
                maxSize={50}
              ></TagCloud>
            </AccordionDetails>
          </Accordion>

          <Accordion
            className={classes.innerAccordion}
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            style={{
              backgroundColor: "rgb(255, 147, 110, 0.1)"
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
              <FiberManualRecordIcon className={classes.dotIcon} style={{ color: "rgb(255, 147, 110)" }} />
              <Typography className={classes.heading} style={{ color: "rgb(255, 147, 110)" }}>
                Tree
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TagCloud
                className={classes.accordionDetails}
                tags={trees}
                renderer={predefinedTags}
                disableRandomColor={true}
                shuffle={false}
                minSize={1}
                maxSize={50}
              ></TagCloud>
            </AccordionDetails>
          </Accordion>

          <Accordion
            className={classes.innerAccordion}
            expanded={expanded === "panel4"}
            onChange={handleChange("panel4")}
            style={{
              backgroundColor: "rgb(64, 84, 219, 0.1)"
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header">
              <FiberManualRecordIcon className={classes.dotIcon} style={{ color: "rgb(64, 84, 219)" }} />
              <Typography className={classes.heading} style={{ color: "rgb(64, 84, 219)" }}>
                Star
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TagCloud
                className={classes.accordionDetails}
                tags={stars}
                renderer={predefinedTags}
                disableRandomColor={true}
                shuffle={false}
                minSize={1}
                maxSize={50}
              ></TagCloud>
            </AccordionDetails>
          </Accordion>

          <Accordion
            className={classes.innerAccordion}
            expanded={expanded === "panel5"}
            onChange={handleChange("panel5")}
            style={{
              backgroundColor: "rgb(170, 170, 170, 0.1)"
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5a-content" id="panel5a-header">
              <FiberManualRecordIcon className={classes.dotIcon} style={{ color: "rgb(170, 170, 170)" }} />
              <Typography className={classes.heading} style={{ color: "rgb(170, 170, 170)" }}>
                Unbestimmt
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography style={{ color: "rgb(170, 170, 170)" }}>
                In dieser Gruppe landen Schlüsselwörter, die nicht nah genug an anderen Gruppen waren - also den Taxa in
                den anderen Gruppen zu unähnlich waren.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </CardContent>
      </Card>
    </div>
  );
}
